/* eslint-disable @typescript-eslint/explicit-function-return-type */

import { LocalStorage, LocalStorageKey, LocalStorageValue, LocalStorageValueSetter } from '~libs.typescript';

import { useLayoutEffect, useState } from '../../react';

export type LocalStorageStateKey = LocalStorageKey;
export type UseLocalStorageStateReturnFn<VALUE> = [LocalStorageValue<VALUE>, LocalStorageValueSetter<VALUE>];

export const createLocalStorageState = <VALUE>(localStorage: LocalStorage<VALUE>) => {
   return (initialValue?: LocalStorageValue<VALUE>): UseLocalStorageStateReturnFn<VALUE> => {
      const [value, setState] = useState<LocalStorageValue<VALUE>>(localStorage.getValue() ?? initialValue);
      useLayoutEffect(() => localStorage.registerSetter(setState), []);
      return [value, localStorage.setValue];
   };
};
